import { X } from 'lucide-react';
import { Button } from './Button';
import React from 'react';

interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  isLoading?: boolean;
  loadingText?: string;
  confirmButtonColor?: string;
  confirmButtonHoverColor?: string;
  cancelButtonColor?: string;
  cancelButtonHoverColor?: string;
}

export const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = 'Confirmar',
  cancelText = 'Cancelar',
  isLoading = false,
  loadingText = 'Processando...',
  confirmButtonColor = 'bg-red-600',
  cancelButtonColor = 'bg-gray-600',
  confirmButtonHoverColor = 'hover:bg-red-700',
  cancelButtonHoverColor = 'hover:bg-gray-700',
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      {/* Overlay - removido o onClick */}
      <div className="fixed inset-0 bg-black bg-opacity-50 transition-opacity" />

      {/* Modal */}
      <div className="flex min-h-full items-center justify-center p-4">
        <div className="relative bg-white rounded-lg shadow-xl max-w-md w-full p-6 overflow-hidden">
          {/* Botão fechar - opcional, você pode remover se quiser */}
          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-gray-400 hover:text-gray-500"
          >
            <X size={20} />
          </button>

          {/* Conteúdo */}
          <div className="mb-6 text-left overflow-hidden">
            <h3 className="text-lg font-medium text-gray-900 mb-2 text-left break-words" style={{ wordWrap: 'break-word', overflowWrap: 'break-word' }}>
              {title}
            </h3>
            <p className="text-sm text-gray-500 text-left break-words whitespace-normal" style={{ wordWrap: 'break-word', overflowWrap: 'break-word' }}>
              {message}
            </p>
          </div>

          {/* Ações */}
          <div className="flex gap-3 justify-end">
            <Button
              onClick={onClose}
              className={`${cancelButtonColor} text-white ${cancelButtonHoverColor}`}
            >
              {cancelText}
            </Button>
            <Button
              onClick={onConfirm}
              isLoading={isLoading}
              loadingText={loadingText}
              className={`${confirmButtonColor} text-white ${confirmButtonHoverColor}`}
            >
              {confirmText}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}; 